
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book-a-session",
      function () {
        return require("private-next-pages/book-a-session.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book-a-session"])
      });
    }
  